// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-2OO5V","header":"header-xKT9b","body":"body-2Ju4l","footer":"footer-3KeFJ","title":"title-3F_Dj"};